// src/utils/importRemote.js
import React from 'react';
import { loadRemoteApplications } from '../loadRemoteApplications';
import { loadRemoteModule } from './loadRemoteModule';

const LIMS_SCOPE = 'MHEA_LIMS';
const LIMS_URL = process.env.LIMS_HOST_WP;
export async function importRemote(moduleName) {
  try {
    // Dynamically load remote module at runtime
    return await loadRemoteModule(LIMS_SCOPE, `./${moduleName}`);
  } catch (error) {
    console.warn(`[MF] Remote not ${LIMS_SCOPE} found, please handle it`, error);
    // You can create a fallback React component locally to show an error UI
    return {
      default: () => (
        <div  title={`Error: ${moduleName} could not be loaded from remote ${LIMS_SCOPE}.`}>
          
        </div>
      ),
    };
  }
}
